import React, { createContext, useContext, useState } from 'react';

const EditBarDialogContext = createContext();

export const useEditBarDialog = () => {
  const context = useContext(EditBarDialogContext);
  if (!context) {
    throw new Error('useEditBarDialog must be used within EditBarDialogProvider');
  }
  return context;
};

export const EditBarDialogProvider = ({ children }) => {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [editingBarData, setEditingBarData] = useState(null);
  const [onSaveCallback, setOnSaveCallback] = useState(null);
  const [onDeleteCallback, setOnDeleteCallback] = useState(null);

  const openEditDialog = (barData, onSave, onDelete) => {
    setEditingBarData(barData);
    setOnSaveCallback(() => onSave);
    setOnDeleteCallback(() => onDelete);
    setShowEditDialog(true);
  };

  const closeEditDialog = () => {
    setShowEditDialog(false);
    setEditingBarData(null);
    setOnSaveCallback(null);
    setOnDeleteCallback(null);
  };

  return (
    <EditBarDialogContext.Provider 
      value={{ 
        showEditDialog,
        editingBarData,
        openEditDialog,
        closeEditDialog,
        onSaveCallback,
        onDeleteCallback
      }}
    >
      {children}
    </EditBarDialogContext.Provider>
  );
};
